// import React, { useEffect, useState } from "react";
// import useHttp from "../../../../hook/use-http"; import { Chart } from 'react-google-charts';
// import NoData from "../../NoData";
// import ChartLoader from '../../ChartLoader';
// import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
// import WaterMark from "../../DashboardMain_Orion/WaterMark";
// import { BsZoomIn } from "react-icons/bs";
// import { Bar } from "react-chartjs-2";
// import CommanBarTable_Orion from "../CommanBarTable_Orion";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   scales
// } from "chart.js";
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );
// let Maxchartdata
// let res_result

// function AverageChargeCurrentCycles_Orion({ apiend, gloablfilter, type }) {
//   const [chartdata, setChartData] = useState([]);
//   const { isLoading, error, sendReq: fetchData } = useHttp();
//   const [chartname, SetChartName] = useState("Avg Charging Current");
//   let barcolor
//   let toPush = [];
//   let toPushfast = [];
//   const appyDataCycles = (data) => {
//     res_result = data;
//     toPush = [];
//     let responce = {
//       "<=90": 0,
//       "120": 0,
//       "150": 0,
//       "180": 0,
//       "210": 0,
//       "240": 0,
//       "270": 0,
//       "300": 0,
//       "330": 0,
//       ">330": 0,
//     }

//     if (res_result.length !== 0) {
//       let d = res_result[0];

//       if (d.B1.value)
//         responce["<=90"] = d.B1.value
//       if (d.B2.value)
//         responce["120"] = d.B2.value
//       if (d.B3.value)
//         responce["150"] = d.B3.value
//       if (d.B4.value)
//         responce["180"] = d.B4.value
//       if (d.B5.value)
//         responce["210"] = d.B5.value
//       if (d.B6.value)
//         responce["240"] = d.B6.value
//       if (d.B7.value)
//         responce["270"] = d.B7.value
//       if (d.B8.value)
//         responce["300"] = d.B8.value
//       if (d.B9.value)
//         responce["330"] = d.B9.value
//       if (d.B10.value)
//         responce[">330"] = d.B10.value

//       toPush.push(d.B1.value)
//       toPush.push(d.B2.value)
//       toPush.push(d.B3.value)
//       toPush.push(d.B4.value)
//       toPush.push(d.B5.value)
//       toPush.push(d.B6.value)
//       toPush.push(d.B7.value)
//       toPush.push(d.B8.value)
//       toPush.push(d.B9.value)
//       toPush.push(d.B10.value)

//       let res_result_final = [["Element", "Count", { role: "style" }]]
//       let loop_keys = Object.keys(responce);

//       loop_keys = ["<=90", "120", "150", "180", "210", "240", "270", "300", "330", ">330"]
//       let countcheck = 0
//       for (const key in responce) {
//         if (responce[key] > 0) {
//           countcheck = countcheck + 1
//         }
//       }
//       loop_keys.map(x => {
//         if (countcheck)
//           // barcolor
//           res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
//       })
//       const labels = ["<=90", "120", "150", "180", "210", "240", "270", "300", "330", ">330"]

//       Maxchartdata = {
//         labels,
//         datasets: [
//           {
//             label: "Amps",
//           data: labels.map(label => responce[label] || 0),
//             backgroundColor: barcolor,
//             borderWidth: 1,
//             borderColor: "black",
//           },
//         ]
//       };
//       setChartData((prestate) => res_result_final);
//     } else {
//       setChartData((prestate) => []);
//     }
//   }

//   const options1 = {
//     responsive: true,
//     categoryPercentage: 1.0,
//     barPercentage: 1.0,
//     scales: {
//       x: {
//         grid: {
//           color: 'white',
//         },
//         title: {
//           display: true,
//           text: 'Amps'
//         },
//         suggestedMin: 0,
//         ticks: {
//           autoSkip: false,
//           maxRotation: 0,
//           minRotation: 0,
//         }
//       },

//       y: {
//         grid: {
//           color: 'white',
//         },
//         title: {
//           display: true,
//           text: 'Charging Cycles'
//         },
//         suggestedMin: 0,
//       },
//     },

//     plugins: {
//       legend: {
//         display: false
//       },
//     }
//   }

//   const options = {
//     hAxis: {
//       gridlines: {
//         color: 'transparent'
//       },
//       title: 'Amps',
//       minValue: 0,
//       format: 'short',
//       direction: 1,
//       slantedText: true,
//       slantedTextAngle: 90
//     },

//     vAxis: {
//       gridlines: {
//         color: 'transparent'
//       },
//       title: 'Charging Cycles',
//       minValue: 0,
//       format: 'short',

//     },
//     bar: { groupWidth: "100%" },
//     legend: "none",
//     series: {
//       0: { color: "#3578b0" },
//     },
//   };

//   useEffect(() => {
//     fetchData({ url: API_URL_MAIN + "orion_charging_analysis/" + apiend, body: { filterdata: gloablfilter } }, appyDataCycles)
//     barcolor = "#3578b0"
//     SetChartName("Avg Charging Current");
//   }, [gloablfilter, type])

//   const [toPushPopUp, settoPushPopUp] = useState([]);
//   const appyDataClick = (data) => {
//     let toPushPopUpArr = []
//     let hits = data;

//     hits.map((i, key) => {
//       toPushPopUpArr.push({
//         "key": {
//           "vehicleId": i.key.vehicleId,
//           "Depot_Name": i.key.Depot_Name,
//           "DLR_ORG_CITY": i.key.DLR_ORG_CITY,
//           "vehicle_registration_number": i.key.vehicle_registration_number
//         },
//         "doc_count": 9,
//         "median_avgChargingCurrent": {
//           "values": {
//             "50.0": i.doc_count
//           }
//         }
//       })
//     })
//     toPushPopUpArr.sort((a, b) => b.median_avgChargingCurrent.values["50.0"] - a.median_avgChargingCurrent.values["50.0"]);
//     settoPushPopUp(toPushPopUpArr)
//   }

//   return (
//     <>
//       <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
//         <div className="modal-dialog modal-lg">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
//               <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
//             </div>
//             <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
//               {
//                 (isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
//                   : <NoData />
//                 )}
//             </div>
//           </div>
//         </div>
//       </div>
//       <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>

//       <WaterMark />

//       {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Chart chartType="ColumnChart" width="100%" height="230px" data={chartdata} options={options} chartEvents={[
//         {
//           eventName: "select",
//           callback({ chartWrapper }) {
//             const chart = chartWrapper.getChart()
//             const selection = chart.getSelection()
//             const [selectedItem] = selection;
//             const { row } = selectedItem;
//             const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);

//             let from_bucket;
//             let to_bucket;
//             const count = chartWrapper.getDataTable().Wf[row].c[1].v;
//             if (count !== 0) {
//               if (barvalue === "<=90") {
//                 from_bucket = 0
//                 to_bucket = 90
//               } else if (barvalue === ">330") {
//                 from_bucket = 330
//                 to_bucket = null
//               } else {
//                 from_bucket = barvalue - 30
//                 to_bucket = barvalue
//               }

//               fetchData({ url: API_URL_MAIN + "orion_charging_analysis/average_cycles_click", body: { filterdata: gloablfilter, type: "Slow", from_bucket: parseInt(from_bucket), to_bucket: parseInt(to_bucket) } }, appyDataClick)
//               window.$('#exampleModal__' + apiend).modal('show');
//             }
//           }
//         }
//       ]}
//       /> : <NoData />)}

//       <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
//         <div className="modal-dialog modal-lg">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
//               <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
//             </div>
//             {/* <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}> */}
//             <div className="modal-body">
//               {/* <table className="table table-striped">
//                 <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
//                   <tr>
//                     <th scope="col">Vin Number</th>
//                     <th scope="col">Cycles Count</th>
//                   </tr></thead>
//                 <tbody> */}
//               <CommanBarTable_Orion data={toPushPopUp} tabDataKey={"median_avgChargingCurrent"} />
//               {/* </tbody></table> */}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default AverageChargeCurrentCycles_Orion;

import React, { useEffect, useState } from "react";
import useHttp from "../../../../hook/use-http";
import { Chart } from 'react-google-charts';
import NoData from "../../NoData";
import ChartLoader from '../../ChartLoader';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import WaterMark from "../../DashboardMain_Orion/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { Bar } from "react-chartjs-2";
import CommanBarTable_Orion from "../CommanBarTable_Orion";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

let Maxchartdata
let res_result

function AverageChargeCurrentCycles_Orion({ apiend, gloablfilter, type }) {
  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [chartname, SetChartName] = useState("Avg Charging Current");
  let barcolor
  let toPush = [];
  let toPushfast = [];

  // Mapping for x-axis labels
  const xAxisMapping = {
    "<=90": "<25",
    "120": "25-50",
    "150": "50-75",
    "180": "75-100",
    "210": "100-125",
    "240": "125-150",
    "270": ">150",
    "300": ">150",
    "330": ">150",
    ">330": ">150",
  };

  const appyDataCycles = (data) => {
    res_result = data;
    toPush = [];
    let responce = {
      "<=90": 0,
      "120": 0,
      "150": 0,
      "180": 0,
      "210": 0,
      "240": 0,
      "270": 0,
      "300": 0,
      "330": 0,
      ">330": 0,
    }

    if (res_result.length !== 0) {
      let d = res_result[0];

      if (d.B1?.value) responce["<=90"] = d.B1.value;
      if (d.B2?.value) responce["120"] = d.B2.value;
      if (d.B3?.value) responce["150"] = d.B3.value;
      if (d.B4?.value) responce["180"] = d.B4.value;
      if (d.B5?.value) responce["210"] = d.B5.value;
      if (d.B6?.value) responce["240"] = d.B6.value;
      if (d.B7?.value) responce["270"] = d.B7.value;
      if (d.B8?.value) responce["300"] = d.B8.value;
      if (d.B9?.value) responce["330"] = d.B9.value;
      if (d.B10?.value) responce[">330"] = d.B10.value;

      toPush.push(d.B1?.value ?? 0);
      toPush.push(d.B2?.value ?? 0);
      toPush.push(d.B3?.value ?? 0);
      toPush.push(d.B4?.value ?? 0);
      toPush.push(d.B5?.value ?? 0);
      toPush.push(d.B6?.value ?? 0);
      toPush.push(d.B7?.value ?? 0);
      toPush.push(d.B8?.value ?? 0);
      toPush.push(d.B9?.value ?? 0);
      toPush.push(d.B10?.value ?? 0);

      let res_result_final = [["Element", "Count", { role: "style" }]];
      let loop_keys = ["<=90", "120", "150", "180", "210", "240", "270", "300", "330", ">330"];
      let countcheck = 0;
      for (const key in responce) {
        if (responce[key] > 0) {
          countcheck += 1;
        }
      }

      loop_keys.map(x => {
        if (countcheck)
          res_result_final.push([xAxisMapping[x] || x, responce[x] ?? 0, "stroke-width: 1;stroke-color: black;"]);
      });

      const labels = ["<25", "25-50", "50-75", "75-100", "100-125", "125-150", ">150"];

      Maxchartdata = {
        labels,
        datasets: [
          {
            label: "Amps",
            data: labels.map(label => {
              const key = Object.keys(xAxisMapping).find(k => xAxisMapping[k] === label);
              return responce[key] ?? 0;
            }),
            backgroundColor: barcolor,
            borderWidth: 1,
            borderColor: "black",
          },
        ]
      };
      setChartData(res_result_final);
    } else {
      setChartData([]);
    }
  }

  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,
    scales: {
      x: {
        grid: { color: 'white' },
        title: { display: true, text: 'Amps' },
        suggestedMin: 0,
        ticks: { autoSkip: false, maxRotation: 0, minRotation: 0 }
      },
      y: {
        grid: { color: 'white' },
        title: { display: true, text: 'Charging Cycles' },
        suggestedMin: 0,
      },
    },
    plugins: { legend: { display: false } }
  }

  const options = {
    hAxis: { gridlines: { color: 'transparent' }, title: 'Amps', minValue: 0, format: 'short', direction: 1, slantedText: true, slantedTextAngle: 90 },
    vAxis: { gridlines: { color: 'transparent' }, title: 'Charging Cycles', minValue: 0, format: 'short' },
    bar: { groupWidth: "100%" },
    legend: "none",
    series: { 0: { color: "#3578b0" } },
  };

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "orion_charging_analysis/" + apiend, body: { filterdata: gloablfilter } }, appyDataCycles);
    barcolor = "#3578b0";
    SetChartName("Avg Charging Current");
  }, [gloablfilter, type]);

  const [toPushPopUp, settoPushPopUp] = useState([]);
  const appyDataClick = (data) => {
    let toPushPopUpArr = [];
    let hits = data;
    hits.map((i) => {
      toPushPopUpArr.push({
        "key": {
          "vehicleId": i.key.vehicleId,
          "Depot_Name": i.key.Depot_Name,
          "DLR_ORG_CITY": i.key.DLR_ORG_CITY,
          "vehicle_registration_number": i.key.vehicle_registration_number
        },
        "doc_count": 9,
        "median_avgChargingCurrent": { "values": { "50.0": i.doc_count } }
      })
    })
    toPushPopUpArr.sort((a, b) => b.median_avgChargingCurrent.values["50.0"] - a.median_avgChargingCurrent.values["50.0"]);
    settoPushPopUp(toPushPopUpArr);
  }

  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
              {isLoading ? <ChartLoader /> : ((chartdata.length > 1) ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" /> : <NoData />)}
            </div>
          </div>
        </div>
      </div>

      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} >
        <BsZoomIn />
      </strong>

      <WaterMark />

      {isLoading ? <ChartLoader /> : ((chartdata.length > 1) ?
        <Chart chartType="ColumnChart" width="100%" height="230px" data={chartdata} options={options} chartEvents={[
          {
            eventName: "select",
            callback({ chartWrapper }) {
              const chart = chartWrapper.getChart()
              const selection = chart.getSelection()
              const [selectedItem] = selection;
              const { row } = selectedItem;
              const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);

              let from_bucket;
              let to_bucket;
              const count = chartWrapper.getDataTable().Wf[row].c[1].v;
              if (count !== 0) {
                if (barvalue === "<25") { from_bucket = 0; to_bucket = 25; }
                else if (barvalue === ">150") { from_bucket = 150; to_bucket = null; }
                else {
                  const split = barvalue.split("-");
                  from_bucket = parseInt(split[0]);
                  to_bucket = parseInt(split[1]);
                }

                fetchData({ url: API_URL_MAIN + "orion_charging_analysis/average_cycles_click", body: { filterdata: gloablfilter, type: "Slow", from_bucket: parseInt(from_bucket), to_bucket: parseInt(to_bucket) } }, appyDataClick)
                window.$('#exampleModal__' + apiend).modal('show');
              }
            }
          }
        ]} /> : <NoData />)}

      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body">
              <CommanBarTable_Orion data={toPushPopUp} tabDataKey={"median_avgChargingCurrent"} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AverageChargeCurrentCycles_Orion;
